var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IToolbarButtonActiveContentType, } from "../../types";
import classnames from "classnames";
import { LoadingSpinner } from "../../../common/loading-spinner";
import { NO_OP } from "../../../common/utils";
var getAriaHasPopup = function (contentType) {
    switch (contentType) {
        case IToolbarButtonActiveContentType.DROPDOWN: {
            return "menu";
        }
        case IToolbarButtonActiveContentType.HORIZONTAL_MENU:
        case IToolbarButtonActiveContentType.MODAL: {
            return "dialog";
        }
        default: {
            return undefined;
        }
    }
};
var getAriaPressed = function (contentType, isExpanded) {
    if (contentType === IToolbarButtonActiveContentType.HEADLESS) {
        return isExpanded;
    }
    return undefined;
};
var getAriaExpanded = function (contentType, isExpanded) {
    // Don't use aria-expanded for headless items, use aria-pressed instead
    if (contentType !== IToolbarButtonActiveContentType.HEADLESS) {
        return isExpanded;
    }
    return undefined;
};
/**
 * Internal component used to render stateful toolbar buttons.
 * This component is used by the ToolbarButtonStateful component.
 * It holds state for the expanded state of the button and updates label, icon and aria label based on the expanded state.
 */
export var ToolbarButtonStatefulControl = function (_a) {
    var _b;
    var _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, label = _a.label, ariaLabel = _a.ariaLabel, activeStateIcon = _a.activeStateIcon, icon = _a.icon, onClick = _a.onClick, disabled = _a.disabled, setButtonContentReferenceElement = _a.setButtonContentReferenceElement, activeStateContentType = _a.activeStateContentType, onKeyDown = _a.onKeyDown, testId = _a.testId, title = _a.title, loadingAriaLabel = _a.loadingAriaLabel;
    var buttonLabel = label;
    var buttonAriaLabel = ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : label;
    var renderedIcon = isSelected ? activeStateIcon !== null && activeStateIcon !== void 0 ? activeStateIcon : icon : icon;
    var ariaHasPopup = getAriaHasPopup(activeStateContentType);
    var ariaPressed = getAriaPressed(activeStateContentType, isSelected);
    var ariaExpanded = getAriaExpanded(activeStateContentType, isSelected);
    return (_jsxs("button", __assign({ disabled: disabled, onClick: isLoading ? NO_OP : onClick, ref: setButtonContentReferenceElement, title: (_b = title !== null && title !== void 0 ? title : label) !== null && _b !== void 0 ? _b : ariaLabel, "aria-label": buttonAriaLabel, "aria-haspopup": ariaHasPopup, "aria-expanded": ariaExpanded, "aria-pressed": ariaPressed, "aria-busy": isLoading, className: classnames("toolbar-button", { selected: isSelected }, { loading: isLoading }, { disabled: disabled }, { labeled: buttonLabel != null }), onKeyDown: isLoading ? NO_OP : onKeyDown, "data-testid": testId }, { children: [isLoading ? (_jsx(LoadingSpinner, { ariaLabel: loadingAriaLabel })) : (renderedIcon), buttonLabel && _jsx("div", __assign({ className: "toolbar-button-label" }, { children: buttonLabel }))] })));
};
